/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Mode_BadgeInputs */



/**
* | output |
* | --- |
* | "Offline Mode" |
*
* @param {Login_Offline_Mode_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_mode_badge = /** @type {((inputs?: Login_Offline_Mode_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Mode_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode Hors Ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offline-Modus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modalità offline")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автономный режим")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo sin conexión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("离线模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフラインモード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफ़लाइन मोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modo offline")
	return /** @type {LocalizedString} */ ("Offline Mode")
});